module.exports = __webpack_public_path__ + "static/media/Learning.092ba96e.png";